import React from "react";
import Particles from "react-tsparticles";

function Particle() {
  return (
    <Particles
      id="tsparticles"
      params={{
        particles: {
          number: {
            value: 48,
            density: {
              enable: true,
              value_area: 1800,
            },
          },
          color: {
            value: ["#047180", "#d4ae37", "#ffffff"],
          },
          line_linked: {
            enable: false,
            opacity: 0.02,
          },
          move: {
            direction: "none",
            random: true,
            speed: 0.12,
          },
          size: {
            value: 1.4,
            random: true,
          },
          opacity: {
            value: 0.24,
            anim: {
              enable: true,
              speed: 0.55,
              opacity_min: 0.08,
            },
          },
        },
        interactivity: {
          events: {
            onclick: {
              enable: false,
              mode: "push",
            },
          },
          modes: {
            push: {
              particles_nb: 1,
            },
          },
        },
        retina_detect: true,
      }}
    />
  );
}

export default Particle;
